var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"w-75 text-dark"},[_c('b-row',{staticClass:"heading p-4"},[_c('b-col',[_c('h2',{staticClass:"h3 text-center"},[_vm._v("Welcome!")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }